import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDateTableHeaderComponent } from './custom-date-table-header/custom-date-table-header.component';
import { CustomTableModule } from '../custom-table/custom-table.module';
import { LastOfMonthPipeModule } from '../last-of-month-pipe/last-of-month-pipe.module';

@NgModule({
  declarations: [CustomDateTableHeaderComponent],
  exports: [CustomDateTableHeaderComponent],
  imports: [CommonModule, CustomTableModule, LastOfMonthPipeModule],
})
export class CustomDateTableModule {}
